import request from '@/config/axios'

// 评价管理 VO
export interface ReviewVO {
  id?: string | number
  shopId: string | number
  hotelName?: string
  roomTypeName?: string
  orderId?: string | number
  memberId?: string | number
  rating: number // 1-5
  content: string
  images?: string
  reply?: string
  replyTime?: string
  status: number // 0待审核 1已发布 2已隐藏
  createTime?: Date
}

// 获取评价分页
export const getReviewPage = (params: any) => {
  return request.get({ url: '/hotel/review/page', params })
}

// 获取评价详情
export const getReview = (id: string | number) => {
  return request.get({ url: '/hotel/review/get?id=' + id })
}

// 创建评价
export const createReview = (data: ReviewVO) => {
  return request.post({ url: '/hotel/review/create', data })
}

// 更新评价
export const updateReview = (data: ReviewVO) => {
  return request.put({ url: '/hotel/review/update', data })
}

// 更新评价状态（平台治理：1=已发布 2=已隐藏）
export const updateReviewStatus = (id: string | number, status: number) => {
  return request.put({ url: '/hotel/review/update', data: { id, status } })
}

// 删除评价
export const deleteReview = (id: string | number) => {
  return request.delete({ url: '/hotel/review/delete?id=' + id })
}

// 批量删除评价
export const deleteReviewList = (ids: (string | number)[]) => {
  return request.delete({ url: '/hotel/review/delete-list?ids=' + ids.join(',') })
}

// 回复评价
export const replyReview = (id: string | number, reply: string) => {
  return request.put({ url: '/hotel/review/reply', params: { id, reply } })
}
